import * as React from "react";
import moment from "moment";

import {dateFormat} from "@/utils/constants";

import "./index.scss";

export default function TQRStatCard(props) {
	const {element} = props;

	const tqr =
		element.tqrValue?.indexOf("-") !== -1
			? element.tqrValue.split(" - ")?.[0]
			: element.tqrValue;
	const currentValue = +parseFloat((tqr * 100) / 20).toFixed(0);

	let tlStatusClassName = "";
	if (currentValue <= 64) {
		tlStatusClassName = "strong";
	} else if (currentValue > 64 && currentValue <= 80) {
		tlStatusClassName = "medium";
	} else if (currentValue > 80) {
		tlStatusClassName = "light";
	}

	return (
		<div className="tqr-stat-card-container">
			<div className="tqr-stat-card-header">
				<div className="top-left">
					{moment(element.tqrDate).format(dateFormat)}
				</div>
				<div className="top-right">
					<span className="tqr-value-label">TQR</span>
					<span className="tqr-value">{element.tqrValue}</span>
				</div>
			</div>
			<div className="tqr-stat-card-body">
				<div className="tqr-percentage-container">
					<div className={"tqr-percentage " + tlStatusClassName}>
						<span className="percentage-value">{currentValue}</span>
						<span className="percentage-symbol">%</span>
					</div>
					<div className="tqr-status-label">
						{tlStatusClassName === "light"
							? "Ottimo"
							: tlStatusClassName === "medium"
								? "Buono"
								: "Attenzione"}
					</div>
				</div>
				<div className="tqr-progress-bar">
					<div
						className={"tqr-progress-fill " + tlStatusClassName}
						style={{width: currentValue + "%"}}
					></div>
				</div>
			</div>
		</div>
	);
}
